import { BASKET_TYPES, removeItemFromBasket, restoreBackup, selectBasket, syncBasket } from 'containers/OrderDetails/basketSlice'
import ReservationFailedPopup from 'layouts/Popups/ReservationFailedPopup'
import { useHistory, useLocation } from 'react-router-dom'
import { addNotification } from './notificationsSlice'
import { useDispatch, useSelector } from 'react-redux'
import useTranslation from 'hooks/useTranslation'
import { useEffect, useState } from 'react'

const FORM_PATHS = 'order|contract|login|registration|shop|payment|oauth'

const Reservation = () => {
  const { isPaid, backup, time, lastSentTime, unlock = false, errors, list, invoice, paymentInProgress } = useSelector(selectBasket)
  const [reservation, setReservation] = useState(true)
  const { pathname } = useLocation()

  const { t } = useTranslation('reservation')
  const dispatch = useDispatch()
  const { push } = useHistory()

  const reg = new RegExp(`${unlock ? 'map|' : ''}${FORM_PATHS}`)
  const isFormPath = !!pathname.match(reg)

  const send = () => {
    dispatch(syncBasket())
  }

  useEffect(() => {
    if (time && !isFormPath) dispatch(removeItemFromBasket())
  }, [dispatch, isFormPath, time])

  useEffect(() => {
    if (!paymentInProgress && lastSentTime) {
      const time = lastSentTime - Date.now()
      const timeout = setTimeout(send, time)
      return () => {
        clearTimeout(timeout)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lastSentTime, paymentInProgress])

  useEffect(() => {
    const cartIsRestored = window.location.pathname.includes('order/finalize')
    if (!isPaid && !cartIsRestored && !paymentInProgress && isBasketValid(list)) {
      const timeout = setTimeout(send, 100)
      return () => {
        clearTimeout(timeout)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [list, invoice, paymentInProgress, isPaid])

  useEffect(() => {
    if (backup) {
      setReservation(!isFormPath)
      const timeout = setTimeout(() => { dispatch(restoreBackup(false)) }, 6000)
      return () => {
        clearTimeout(timeout)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, backup])

  if (errors) return <ReservationFailedPopup />
  if (!backup) return null
  return (
    <div className='notification'>
      <div className='notification__desc'>{t(reservation ? 'reservationNotCompleted' : 'undoActionQuestion')}</div>
      <div
        className='center --gap05'
        style={{ alignItems: 'stretch' }}>
        <div className='notification__button --secFont' onClick={() => {
          if (pathname.includes('order')) {
            dispatch(restoreBackup(true))

          } else {
            const lastItem = Array.isArray(backup?.list)
              ? backup.list.findLast(l => l.type === BASKET_TYPES.rent)
              : undefined
            if (lastItem.identifier) {
              dispatch(restoreBackup(true))
              push(`/order/${lastItem.identifier}`)
            } else {
              dispatch(addNotification({ type: 'error', message: t('failedToRestoreCart') }))
            }
          }
        }}>{t(reservation ? 'goBack' : 'undo')}</div>
        <div
          className='notification__button--close center'
          onClick={() => {
            dispatch(restoreBackup(false))
          }}>
          <i className='icon icon--close' />
        </div>
      </div>
    </div>
  )
}

const isBasketValid = (list) => {
  if (!list || list.length === 0) return false
  for (const item of list) {
    if (item.type === BASKET_TYPES.rent && !item.ok) {
      return false
    }
  }
  return true
}

export default Reservation